<div class="header">
  <h1>Image to Text Converter</h1>
  <p>Extract text from images using OCR technology.</p>
</div>